<div class="modal-header">
	<h4 class="modal-title">Signing Links History</h4>
	<button type="button" class="btn-close" data-dismiss="modal" tabindex="-1" (click)="reset()" aria-label="Close"></button>
</div>
<div class="modal-body">
	<table class="table table-responsive">
		<thead>
			<tr>
				<th>Details</th>
				<th>Link(s)</th>
			</tr>
		</thead>
		<tbody>
			@if (dsList.length > 0) {
				@for (ds of dsList; track ds) {
					<tr>
						<td>
							<p>{{ ds.createdAt | date: 'dd/MM/yyyy hh:mm:ss a' }}</p>
						</td>
						<td>
							@if (ds.documentsUrl == undefined) {
								@if (ds.customerLink != undefined) {
									<button class="btn btn-dark d-block" (click)="copySignLink(ds.customerLink, 'Customer')"><i class="fas fa-link"></i> Customer Link</button>
								}

								@if (ds.contactLink != undefined) {
									<button class="btn btn-secondary d-block" (click)="copySignLink(ds.contactLink, 'Guarantor')"><i class="fas fa-link"></i> Guarantor Link</button>
								}

								@if (ds.link != undefined) {
									<button class="btn btn-secondary d-block" (click)="copySignLink(ds.link, 'Customer')"><i class="fas fa-link"></i> Sign Link</button>
								}
							} @else {
								<button class="btn btn-outline-success d-block mb-1" (click)="downloadSignedDoc(ds.documentsUrl)"><i class="fas fa-file-download"></i> Download Signed Doc</button>
							}
						</td>
					</tr>
				}
			} @else {
				<p>This contact does not have any signing link yet</p>
			}
		</tbody>
	</table>
</div>
